import { render, staticRenderFns } from "./ButtonBoard.vue?vue&type=template&id=81e01aee&scoped=true&"
import script from "./ButtonBoard.vue?vue&type=script&lang=js&"
export * from "./ButtonBoard.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBoard.vue?vue&type=style&index=0&id=81e01aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e01aee",
  null
  
)

export default component.exports